/**
 * @function removeQueryStringParameter
 * @memberof Promega.Util
 * @description Given a URL-like string, removes the given query string parameter and returns the resulting string.
 * @param {String} url The URL to modify
 * @param {String} parameter The query string parameter to remove
 * @returns {String} A new string with the specified parameter removed from it
 */
export default function removeQueryStringParameter (url, parameter) {
    let urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        let prefix = encodeURIComponent(parameter) + '=',
            pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i= pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}
